/**
 * Landing Form - Integração com Shopify Forms API + hCaptcha
 * Formulário de leads para landing pages Furlan
 * Versão sem jQuery (vanilla JS)
 * Após sucesso no Shopify Forms, dispara (fire-and-forget) o lead
 * para o webhook n8n (Meetime + Slack), sem nunca bloquear o submit.
 */

(() => {
  var SHOPIFY_FORMS_ENDPOINT =
    "https://forms.shopifyapps.com/api/v2/form_submission";

  function initLandingForm() {
    var form = document.querySelector("#LandingForm");
    if (!form) return;

    var submitting = false;

    var formInstanceId =
      form.getAttribute("data-form-instance-id") || form.dataset.formInstanceId;
    var shopifyDomain =
      form.getAttribute("data-shopify-domain") || form.dataset.shopifyDomain;

    setupMasks(form);
    setupInputFilters(form);

    form.addEventListener("submit", (event) => {
      event.preventDefault();

      if (submitting) {
        return;
      }

      var isValid = validateForm(form);
      if (!isValid) {
        return;
      }

      var hCaptchaResponse = getHCaptchaResponse();
      if (!hCaptchaResponse) {
        showCaptchaError("Por favor, complete a verificação de segurança.");
        return;
      }

      var submitBtn = form.querySelector('button[type="submit"]');
      var originalText = submitBtn ? submitBtn.textContent : "";
      submitting = true;
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = "Enviando...";
      }

      var formData = collectFormData(form);
      var payload = buildPayload(
        formInstanceId,
        shopifyDomain,
        hCaptchaResponse,
        formData,
      );

      submitToShopifyForms(payload)
        .then((result) => {
          var success = handleSubmissionResult(form, result);
          if (success) {
            submitLeadToN8n(form, payload);
          }
        })
        .catch((error) => {
          console.error("Erro ao enviar formulário:", error);
          showError(
            form,
            "Ocorreu um erro ao enviar. Por favor, tente novamente.",
          );
          resetHCaptcha();
        })
        .finally(() => {
          submitting = false;
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }
        });
    });

    form.querySelectorAll("input, select, textarea").forEach((field) => {
      field.addEventListener("input", (event) => {
        clearFieldError(form, event.target);
      });
      field.addEventListener("change", (event) => {
        clearFieldError(form, event.target);
      });
    });
  }

  function setupMasks(form) {
    form.querySelectorAll(".lp-form__input--cnpj").forEach((input) => {
      input.addEventListener("input", (event) => {
        event.target.value = applyMask(
          event.target.value,
          "00.000.000/0000-00",
        );
      });
    });

    form.querySelectorAll(".lp-form__input--phone").forEach((input) => {
      input.addEventListener("input", (event) => {
        var value = String(event.target.value || "");
        if (value.trim().indexOf("+") === 0) {
          event.target.value = value.replace(/[^0-9+]/g, "");
          return;
        }
        event.target.value = applyMask(value, "(00) 00000-0000");
      });
    });

    form.querySelectorAll(".lp-form__input--cep").forEach((input) => {
      input.addEventListener("input", (event) => {
        event.target.value = applyMask(event.target.value, "00000-000");
      });
    });
  }

  function setupInputFilters(form) {
    var nameInput = form.querySelector("#LandingForm-name");
    if (nameInput) {
      nameInput.addEventListener("input", (event) => {
        var value = event.target.value;
        event.target.value = value.replace(/[^a-zA-ZÀ-ÿ\s]/g, "");
      });
    }

    var companyInput = form.querySelector("#LandingForm-company");
    if (companyInput) {
      companyInput.addEventListener("input", (event) => {
        var value = event.target.value;
        event.target.value = value.replace(/[^a-zA-ZÀ-ÿ0-9\s.\-&]/g, "");
      });
    }
  }

  function applyMask(value, mask) {
    return applyInputMask(value, mask);
  }

  function onlyDigits(value) {
    return String(value || "").replace(/\D/g, "");
  }

  function normalizeBrDigits(digits) {
    if (digits.charAt(0) === "0") {
      return digits.substring(1);
    }
    return digits;
  }

  function isRepeatedDigits(digits) {
    return /^(\d)\1*$/.test(digits);
  }

  function isValidBrNationalNumber(national) {
    if (national.length !== 10 && national.length !== 11) return false;
    if (isRepeatedDigits(national)) return false;

    var ddd = parseInt(national.substring(0, 2), 10);
    if (ddd < 11 || ddd > 99) return false;

    var number = national.substring(2);
    if (isRepeatedDigits(number)) return false;
    if (national.length === 11) return number.charAt(0) === "9";
    return number.charAt(0) >= "2" && number.charAt(0) <= "9";
  }

  function cnpjCheckDigit(digits, position) {
    var weights =
      position === 12
        ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
        : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    var sum = 0;

    for (var i = 0; i < weights.length; i++) {
      sum += parseInt(digits.charAt(i), 10) * weights[i];
    }

    var remainder = sum % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  }

  function isValidCnpj(digits) {
    if (digits.length !== 14 || isRepeatedDigits(digits)) return false;
    return (
      cnpjCheckDigit(digits, 12) === parseInt(digits.charAt(12), 10) &&
      cnpjCheckDigit(digits, 13) === parseInt(digits.charAt(13), 10)
    );
  }

  var PHONE_INVALID_MESSAGE = "Telefone inválido (verifique DDD e número)";

  /**
   * Declarative validation rules for landing form fields.
   * Each rule: { selector, validate(value) -> string|null }
   * Returns an error message string on failure, or null on success.
   */
  var FIELD_VALIDATION_RULES = [
    {
      selector: "#LandingForm-cnpj",
      validate: (value) => {
        var digits = onlyDigits(value);
        if (!digits) return null;
        if (digits.length < 14) return "CNPJ incompleto";
        if (!isValidCnpj(digits)) return "CNPJ inválido";
        return null;
      },
    },
    {
      selector: "#LandingForm-phone",
      validate: (value) => {
        var trimmed = String(value || "").trim();
        var isInternational = trimmed.charAt(0) === "+";
        var digits = normalizeBrDigits(onlyDigits(trimmed));
        var hasBrCountryCode = digits.substring(0, 2) === "55";

        if (!digits || isRepeatedDigits(digits)) return PHONE_INVALID_MESSAGE;

        if (isInternational && !hasBrCountryCode) {
          return digits.length >= 8 && digits.length <= 15
            ? null
            : PHONE_INVALID_MESSAGE;
        }

        var national =
          hasBrCountryCode && (digits.length === 12 || digits.length === 13)
            ? digits.substring(2)
            : digits;

        return isValidBrNationalNumber(national)
          ? null
          : PHONE_INVALID_MESSAGE;
      },
    },
    {
      selector: "#LandingForm-cep",
      validate: (value) => {
        var clean = value.replace(/\D/g, "");
        if (clean.length > 0 && clean.length < 8) return "CEP incompleto";
        return null;
      },
    },
    {
      selector: "#LandingForm-email",
      validate: (value) => {
        var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(value)) return "E-mail inválido";
        return null;
      },
    },
    {
      selector: "#LandingForm-name",
      validate: (value) => {
        if (value.trim().length < 3)
          return "Nome deve ter pelo menos 3 caracteres";
        return null;
      },
    },
  ];

  function validateForm(form) {
    var isValid = true;
    var errorContainer = form.querySelector(".form-error");

    clearErrors(form);

    // Required field check
    form.querySelectorAll("[required]").forEach((field) => {
      var value = field.value;
      if (!value || value.trim() === "") {
        setFieldError(field, "Este campo é obrigatório");
        isValid = false;
      }
    });

    // Declarative field-level rules
    FIELD_VALIDATION_RULES.forEach((rule) => {
      var field = form.querySelector(rule.selector);
      if (field && field.value) {
        var error = rule.validate(field.value);
        if (error) {
          setFieldError(field, error);
          isValid = false;
        }
      }
    });

    if (!isValid && errorContainer) {
      errorContainer.textContent =
        "Por favor, preencha todos os campos corretamente.";
      errorContainer.style.display = "block";

      var firstError = form.querySelector(".field--error");
      if (firstError) {
        scrollToElement(firstError);
        var firstInvalidInput = firstError.querySelector(
          "input, select, textarea",
        );
        if (firstInvalidInput) {
          firstInvalidInput.focus();
        }
      }
    }

    return isValid;
  }

  function collectFormData(form) {
    var preferenciaContato = form.querySelector(
      "#LandingForm-contact-preference",
    );

    return {
      email: getValue(form, "#LandingForm-email"),
      first_name: getValue(form, "#LandingForm-name"),
      phone: getValue(form, "#LandingForm-phone"),
      cnpj: getValue(form, "#LandingForm-cnpj"),
      cep: getValue(form, "#LandingForm-cep"),
      empresa: getValue(form, "#LandingForm-company"),
      necessidade: getValue(form, "#LandingForm-message"),
      preferencia_contato: preferenciaContato ? preferenciaContato.value : "",
      email_marketing:
        preferenciaContato && preferenciaContato.value === "E-MAIL",
    };
  }

  function getValue(form, selector) {
    var field = form.querySelector(selector);
    return field && field.value ? field.value.trim() : "";
  }

  function buildPayload(formInstanceId, shopifyDomain, hCaptchaResponse, data) {
    var phone = (data.phone || "").trim();
    var isInternational = phone.charAt(0) === "+";
    var phoneDigits = normalizeBrDigits(phone.replace(/\D/g, ""));
    var hasBrCountryCode =
      phoneDigits.substring(0, 2) === "55" &&
      (phoneDigits.length === 12 || phoneDigits.length === 13);
    var phoneFormatted = "";

    if (isInternational || hasBrCountryCode) {
      phoneFormatted = "+" + phoneDigits;
    } else {
      phoneFormatted = "+55" + phoneDigits;
    }

    var cnpjClean = (data.cnpj || "").replace(/\D/g, "");
    var cepClean = (data.cep || "").replace(/\D/g, "");

    if (!cnpjClean) {
      cnpjClean = "00000000000000";
    }

    if (!cepClean) {
      cepClean = "00000000";
    }

    return {
      shopify_domain: shopifyDomain,
      form_instance_id: parseInt(formInstanceId, 10),
      h_captcha_response: hCaptchaResponse,
      first_name: data.first_name,
      email: data.email,
      phone_number: phoneFormatted,
      "custom#cnpj_1": cnpjClean,
      "custom#cep": cepClean,
      "custom#empresa": data.empresa,
      "custom#necessidade": data.necessidade,
      "custom#como_prefere_receber_o_contato_da_furlan":
        data.preferencia_contato,
      customer_consented_to_email_marketing: data.email_marketing,
      customer_consented_to_sms_marketing: false,
    };
  }

  function submitToShopifyForms(payload) {
    return fetch(SHOPIFY_FORMS_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) =>
        response
          .text()
          .catch(() => "")
          .then((text) => {
            var data = null;
            try {
              data = text ? JSON.parse(text) : null;
            } catch {
              data = null;
            }
            return {
              ok: response.ok || response.status === 202,
              status: response.status,
              data: data,
            };
          }),
      );
  }

  function submitLeadToN8n(form, payload) {
    var enabled = form.getAttribute("data-n8n-enabled");
    var url = (form.getAttribute("data-n8n-webhook-url") || "").trim();
    var secret = (form.getAttribute("data-n8n-webhook-secret") || "").trim();
    var pageName = (form.getAttribute("data-n8n-page-name") || "").trim();

    if (enabled !== "true" || !url) return;

    var n8nPayload = {};
    Object.keys(payload).forEach((key) => {
      if (key !== "h_captcha_response") {
        n8nPayload[key] = payload[key];
      }
    });
    n8nPayload.page_url = window.location.href;
    n8nPayload.submitted_at = new Date().toISOString();
    if (pageName) {
      n8nPayload.page_name = pageName;
    }

    var headers = { "Content-Type": "application/json" };
    if (secret) {
      headers["X-Webhook-Secret"] = secret;
    }

    // Fire-and-forget: nunca bloqueia nem falha o submit principal.
    fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(n8nPayload),
    }).catch((error) => {
      console.warn("Webhook n8n não disparado:", error);
    });
  }

  var SERVER_ERROR_FIELDS = {
    phone_number: {
      selector: "#LandingForm-phone",
      message: "Telefone inválido",
    },
    email: {
      selector: "#LandingForm-email",
      message: "E-mail inválido",
    },
    first_name: {
      selector: "#LandingForm-name",
      message: "Nome inválido",
    },
    h_captcha_response: {
      captcha: true,
      message:
        "Verificação de segurança inválida ou expirada. Tente novamente.",
    },
    "custom#cnpj_1": {
      selector: "#LandingForm-cnpj",
      message: "CNPJ inválido",
    },
    "custom#cep": {
      selector: "#LandingForm-cep",
      message: "CEP inválido",
    },
    "custom#empresa": {
      selector: "#LandingForm-company",
      message: "Empresa inválida",
    },
    "custom#necessidade": {
      selector: "#LandingForm-message",
      message: "Descreva sua necessidade",
    },
    "custom#como_prefere_receber_o_contato_da_furlan": {
      selector: "#LandingForm-contact-preference",
      message: "Selecione uma preferência de contato",
    },
  };

  var SERVER_ERROR_FALLBACK_MESSAGE =
    "Ocorreu um erro ao enviar. Por favor, tente novamente.";

  var SERVER_TOP_LEVEL_MESSAGES = {
    "Invalid User Input": "Revise os campos destacados e tente novamente.",
    "Authentication failed":
      "Erro de configuração do formulário. Avise a equipe técnica.",
  };

  function hasOwn(object, key) {
    return Object.prototype.hasOwnProperty.call(object, key);
  }

  function getServerErrorRule(key) {
    if (hasOwn(SERVER_ERROR_FIELDS, key)) return SERVER_ERROR_FIELDS[key];
    if (key.indexOf("custom#como_prefere") === 0) {
      return SERVER_ERROR_FIELDS[
        "custom#como_prefere_receber_o_contato_da_furlan"
      ];
    }
    return null;
  }

  function normalizeServerErrors(data) {
    var errors = data && data.errors;
    if (!errors || typeof errors !== "object") return [];
    return Object.keys(errors);
  }

  function handleSubmissionResult(form, result) {
    var data = result.data || {};
    var message = typeof data.message === "string" ? data.message.trim() : "";
    var errorKeys = normalizeServerErrors(data);

    if (result.ok && errorKeys.length === 0) {
      showSuccess(form);
      return true;
    }

    clearErrors(form);

    var status = result.status;
    var isAuthFailure =
      status === 401 ||
      message.toLowerCase().indexOf("authentication failed") !== -1;

    if (isAuthFailure) {
      showError(
        form,
        SERVER_TOP_LEVEL_MESSAGES["Authentication failed"] ||
          SERVER_ERROR_FALLBACK_MESSAGE,
      );
      console.error("Resposta do Shopify Forms API:", result);
      resetHCaptcha();
      return;
    }

    applyServerErrors(form, data, errorKeys, message, status);
  }

  function applyServerErrors(form, data, errorKeys, message, status) {
    var firstField = null;
    var captchaFailed = false;
    var unmapped = [];

    errorKeys.forEach((key) => {
      var serverValue = data.errors[key];
      var rule = getServerErrorRule(key);

      if (!rule) {
        unmapped.push(formatUnmappedServerError(key, serverValue));
        return;
      }

      if (rule.captcha) {
        captchaFailed = true;
        showCaptchaError(rule.message, false);
        return;
      }

      var field = form.querySelector(rule.selector);
      if (!field) {
        unmapped.push(formatUnmappedServerError(key, serverValue));
        return;
      }

      setFieldError(field, rule.message);
      if (!firstField) firstField = field;
    });

    var summary = buildServerErrorSummary(message, status, unmapped);

    if (firstField) {
      showError(form, summary, false);
      scrollToElement(firstField.closest(".lp-form__field") || firstField);
      firstField.focus();
    } else if (captchaFailed) {
      showError(form, summary, false);
      var captchaWrapper = form.querySelector(".lp-form__captcha");
      if (captchaWrapper) scrollToElement(captchaWrapper);
    } else {
      showError(form, summary || SERVER_ERROR_FALLBACK_MESSAGE, true);
    }

    console.error("Resposta do Shopify Forms API:", status, data);
    resetHCaptcha();
    return false;
  }

  function formatUnmappedServerError(key, value) {
    var text =
      value && typeof value === "object"
        ? JSON.stringify(value)
        : String(value || "");
    return text || key;
  }

  function buildServerErrorSummary(message, status, unmapped) {
    if (unmapped.length > 0) {
      return "Erro de validação: " + unmapped.join("; ");
    }

    if (hasOwn(SERVER_TOP_LEVEL_MESSAGES, message)) {
      return SERVER_TOP_LEVEL_MESSAGES[message];
    }

    if (status >= 200 && status < 300) {
      return null;
    }

    return SERVER_ERROR_FALLBACK_MESSAGE;
  }

  function getHCaptchaResponse() {
    if (typeof hcaptcha !== "undefined") {
      return hcaptcha.getResponse();
    }
    return null;
  }

  function resetHCaptcha() {
    if (typeof hcaptcha !== "undefined") {
      hcaptcha.reset();
    }
  }

  function showCaptchaError(message, scroll) {
    var captchaError = document.querySelector("#LandingForm-captcha-error");
    var captchaWrapper = document.querySelector(".lp-form__captcha");

    if (captchaWrapper) {
      captchaWrapper.classList.add("field--error");
    }

    if (captchaError) {
      captchaError.textContent = message;
      captchaError.style.display = "block";
    }

    if (captchaWrapper && scroll !== false) {
      scrollToElement(captchaWrapper);
    }
  }

  function showSuccess(form) {
    var successMsg = document.querySelector("#formSuccess");

    form.style.display = "none";

    if (successMsg) {
      successMsg.style.display = "block";
      scrollToElement(successMsg);
      successMsg.focus();
    }
  }

  function showError(form, message, scroll) {
    var errorContainer = form.querySelector(".form-error");

    if (!errorContainer || !message) return;

    errorContainer.textContent = message;
    errorContainer.style.display = "block";

    if (scroll !== false) {
      scrollToElement(errorContainer);
    }
  }

  function setFieldError(field, message) {
    field.classList.add("field--error");
    field.setAttribute("aria-invalid", "true");

    var wrapper = field.closest(".lp-form__field");
    if (!wrapper) return;

    var errorMsg = wrapper.querySelector(".field-error-message");
    if (errorMsg) {
      errorMsg.textContent = message;
      errorMsg.style.display = "block";
    }
  }

  function clearFieldError(form, field) {
    field.classList.remove("field--error");
    field.removeAttribute("aria-invalid");

    var wrapper = field.closest(".lp-form__field");
    if (wrapper) {
      var errorMsg = wrapper.querySelector(".field-error-message");
      if (errorMsg) {
        errorMsg.textContent = "";
        errorMsg.style.display = "none";
      }
    }

    var errorContainer = form.querySelector(".form-error");
    if (errorContainer) {
      errorContainer.textContent = "";
      errorContainer.style.display = "none";
    }

    var captchaWrapper = form.querySelector(".lp-form__captcha");
    if (captchaWrapper) {
      captchaWrapper.classList.remove("field--error");
    }

    var captchaError = form.querySelector("#LandingForm-captcha-error");
    if (captchaError) {
      captchaError.textContent = "";
      captchaError.style.display = "none";
    }
  }

  function clearErrors(form) {
    form.querySelectorAll(".field--error").forEach((field) => {
      field.classList.remove("field--error");
      field.removeAttribute("aria-invalid");
    });

    form.querySelectorAll(".field-error-message").forEach((msg) => {
      msg.textContent = "";
      msg.style.display = "none";
    });

    var errorContainer = form.querySelector(".form-error");
    if (errorContainer) {
      errorContainer.textContent = "";
      errorContainer.style.display = "none";
    }

    var captchaWrapper = form.querySelector(".lp-form__captcha");
    if (captchaWrapper) {
      captchaWrapper.classList.remove("field--error");
    }

    var captchaError = form.querySelector("#LandingForm-captcha-error");
    if (captchaError) {
      captchaError.textContent = "";
      captchaError.style.display = "none";
    }
  }

  function scrollToElement(element) {
    var top = element.getBoundingClientRect().top + window.pageYOffset - 100;
    window.scrollTo({
      top: top,
      behavior: "smooth",
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initLandingForm);
  } else {
    initLandingForm();
  }
})();
